export * from './edit-iris-id-dialog.service';
